import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { TDiscountType } from './dialog/dialog-discount/discount-membership-gift.type';

/** Extension to strongly type ValidationErrors.errorObj */
export interface ValidationErrorObject {
  min?: number;
  max?: number;
  requiredLength?: number;
  actualLength?: number;
  message?: string;
}

/** Generic key/values */
export interface IDictionary<T> {
  [Key: string]: T;
}

/** Generic title and description. */
export interface ITitleDescription {
  code: TDiscountType;
  title: string;
  description: string;
}

/** Roller.Core.Infrastructure.ValidationResults */
export interface IValidationResult<T> {
  isValid: boolean;
  errors?: IValidationFailure[];
  returnValue?: T;
}

/** FluentValidation.Results */
export interface IValidationFailure {
  propertyName: string;
  errorMessage: string;
  errorCode?: string;
}

/** Roller.API.Infrastructure.Exception.Reasons.BaseReason */
export interface IErrorReason {
  message: string;
  params: IErrorParameter[];
}

/** Roller.API.Infrastructure.Exception.Reasons.ErrorParameter */
/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IErrorParameter {
  errorCode?: string;
  attemptedValue?: any;
}

/** Matches Roller.Core.Helpers.JwtHelper */
export interface IJwtWrapper<T> {
  data: T;
  jwt: string;
}

/**
 * Create a simple (form controls only) using an existing interface
 * Credit to RcoderNY for his answer https://stackoverflow.com/questions/72507263/angular-14-strictly-typed-reactive-forms-how-to-type-formgroup-model-using-exi
 * @example: searchForm: FormGroup<TFormControlMap<ISearchRequestDTO>> | undefined;
 */
export type TypedControls<T> = {
  [K in keyof T]: T[K] extends Array<any> ? FormArray<TypedFormGroup<Unbox<T[K]>>> : FormControl<T[K]>;
};
type Unbox<T> = T extends Array<infer V> ? V : T;

export type TypedFormGroup<T> = FormGroup<TypedControls<T>>;

export const SUSPEND_FROM_ONLINE_SALES = 'suspended_from_online_sales';

export type TColors =
  | 'primary'
  | 'secondary'
  | 'accent'
  | 'blank'
  | 'dark-accent'
  | 'success'
  | 'hyperlink'
  | 'warning'
  | 'danger'
  | 'muted'
  | '';
export type TOpenClose = 'open' | 'close';
export type TLeftRight = 'left' | 'right';
export type TAlign = 'left' | 'center' | 'right';

export type TProductItemDirection = 'row' | 'column' | 'row-reverse';

export enum EConflictError {
  FullyBooked = 'fully_booked',
  OutsideSalePeriod = 'outside_sale_period',
  OnlineSalesClosed = 'online_sales_closed',
  ReservationConflict = 'reservation_conflict'
}
